// extracted by mini-css-extract-plugin
module.exports = {"root":"Image__root--2yUDP","container":"Image__container--1I_M-","lazyContainer":"Image__lazyContainer--ADGuJ","image":"Image__image--1g11_","bounce":"Image__bounce--1k2NJ"};